// extracted by mini-css-extract-plugin
export default {"markdownContainer":"Markdown_markdownContainer__NftLz","codeHeader":"Markdown_codeHeader__jzssb","languageLabel":"Markdown_languageLabel__MgGDB"};